export default __webpack_public_path__ + "static/media/user.579a95c2.png";